export const UI_SCHEMA = {
    basic: {
        field_name1: {
            'ui:field': '/schemas/jsf-select'
        },
        field_name2: {
            'ui:field': '/schemas/jsf-select-arrow'
        },
        field_name3: {
            'ui:field': '/schemas/jsf-select-pick-arrow'
        }
    }
};
export const SCHEMA = {
    type: 'object',
    properties: {
        basic: {
            title: 'Компонент: SelectJsField',
            type: 'object',
            required: [],
            properties: {
                field_name1: {
                    title: 'Тип элемента',
                    type: 'string',
                    oneOf: [
                        { const: 'M_Flow', title: 'Материальный поток' },
                        { const: 'E_Flow', title: 'Энергетический поток' },
                        { const: 'T_Flow', title: 'Поток неактивный', readOnly: true }
                    ]
                },
                field_name2: {
                    title: 'Тип элемента',
                    type: 'string',
                    oneOf: [
                        { const: 'M_Flow', title: 'Материальный поток' },
                        { const: 'E_Flow', title: 'Энергетический поток' },
                        { const: 'T_Flow', title: 'Поток неактивный', readOnly: true }
                    ]
                },
                field_name3: {
                    title: 'Тип элемента',
                    type: 'string',
                    oneOf: [
                        { const: 'M_Flow', title: 'Материальный поток' },
                        { const: 'E_Flow', title: 'Энергетический поток' },
                        { const: 'T_Flow', title: 'Поток неактивный', readOnly: true }
                    ]
                }
            }
        }
    }
};
export const FORM_DATA = {
    basic: {
        field_name1: 'M_Flow',
        field_name2: 'M_Flow',
        field_name3: 'M_Flow'
    }
};
//# sourceMappingURL=SelectJsField.example.js.map